export default __webpack_public_path__ + "static/media/refactor.c672fcf0.jpg";